<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div style="height: 16.875rem; max-width: 100%; overflow: auto">
  <div class="row m-0 mb-2 mt-3 w-b p-0 col-md-12 align-items-center justify-content-between">
    <h1 class="fs-12 m-0">Completed Documents:</h1>
    <button type="button" (click)="onDocOpen()" class="btn font-size-12 button-btn">
      Add Documents
    </button>
  </div>
  <div class="table-responsive">
    <mat-table [dataSource]="docDataSource">
      <ng-container matColumnDef="UDId">
        <mat-header-cell class="grid-header mw50" *matHeaderCellDef>#</mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index" class="grid-cell mw50">{{
          i + 1
          }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Category">
        <mat-header-cell class="grid-header" *matHeaderCellDef>Doc Category</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{
          row.Category
          }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Type">
        <mat-header-cell class="grid-header" *matHeaderCellDef>Type</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{
          row.Type
          }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="DocType">
        <mat-header-cell class="grid-header" *matHeaderCellDef>Doc Type</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{
          row.DocType
          }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="DocTitle">
        <mat-header-cell class="grid-header" *matHeaderCellDef>Doc Title</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{
          row.DocTitle
          }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="UploadBy">
        <mat-header-cell class="grid-header" *matHeaderCellDef>Uploaded By</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{
          row.UploadBy
          }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="UploadedOn">
        <mat-header-cell class="grid-header" *matHeaderCellDef>Uploaded On</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{
          row.UploadedOn
          }}</mat-cell>
      </ng-container>

      <!-- <ng-container matColumnDef="IsReceipt">
        <mat-header-cell class="grid-header" *matHeaderCellDef
          >Is Receipt</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="grid-cell">{{
          row.IsReceipt
        }}</mat-cell>
      </ng-container> -->

      <ng-container matColumnDef="Remark">
        <mat-header-cell class="grid-header" *matHeaderCellDef>Remark</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{
          row.Remark
          }}</mat-cell>
      </ng-container>


      <ng-container matColumnDef="No_Of_Pages">
        <mat-header-cell class="grid-header" *matHeaderCellDef>No Of Pages</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{
          row.No_Of_Pages
          }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="View">
        <mat-header-cell class="grid-header text-center" *matHeaderCellDef>Action</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          <!-- <a href="{{ docBaseUrl }}{{ ApplicationDetail.ApplicationNo }}/{{row.FileName}}" target="_blank">View</a>-->
          <a href="javascript:void(0)" (click)="ViewDoc(row)"><i class="fa fa-eye" style="font-size: large"></i></a>
          <!-- <a href="{{ docBaseUrl }}{{ ApplicationDetail.ApplicationNo }}/{{row.UD_DocFileName}}" target="_blank">View</a> -->
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <i class="fas fa-lg fa-edit margin-right-4xs cursor-style" aria-label="true"
            (click)="OnEditApplicationDocs(row)" *ngIf="
              PageData.currentTab == 1 &&
              Status != 'C' &&
              (Status == 'R' ? (Revert_IsEdit == 1 ? true : false) : true)
            "></i>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedDocolumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedDocolumns"></mat-row>
    </mat-table>
  </div>

  <div class="row m-0 mb-2 mt-3 w-b p-0 col-md-12 align-items-center justify-content-between">
    <h1 class="fs-12 m-0">Pending Documents:</h1>
  </div>
  <div class="table-responsive">
    <app-los-pending-document-list [ApplicationId]="ApplicationId" [TypeLoan]="'QuickLoan'" [LoanStatus]="Status"
      (close)="GetData()">
    </app-los-pending-document-list>
  </div>
</div>
<div class="row col-md-12 m-0 mt-2 justify-content-end">
  <button type="button" (click)="CheckCustomerRefInfo()" class="btn font-size-12 button-btn"
    *ngIf="PageData.currentTab == 1 && Status != 'C'">
    Next <i class="fa fa-arrow-right"></i>
  </button>
</div>

<div class="modal fade in" id="docModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle class="modal-content">
      <div class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Upload Application Documents
        </h6>
        <button type="button" (click)="OnDocClose()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row m-0 col-md-12 p-1" *ngIf="docModal">
          <form #df="ngForm" class="row m-0 col-md-12 p-0 formborder" (ngSubmit)="onSaveDoc()" novalidate>
            <div class="row m-0 col-md-12 p-0">
              <div class="col-md-12 p-1">
                <span> Attachment Type</span>
                <div class="col-md-12 p-1">
                  <span class="form-check-inline">
                    <label class="form-check-label mr-4" for="Document">
                      <input type="radio" class="form-check-input" id="Document" name="IsDocument"
                        #refIsDocument="ngModel" [ngClass]="{
                          'is-invalid': df.submitted && refIsDocument.invalid,
                          'alert-warning':
                            refIsDocument.invalid &&
                            (refIsDocument.dirty ||
                              refIsDocument.touched ||
                              refIsDocument.untouched)
                        }" [(ngModel)]="docModal.IsDocument" required value="1" />
                      Document
                    </label>
                    <label class="form-check-label" for="Open">
                      <input type="radio" class="form-check-input" id="Open" name="IsDocument" #refIsDocument="ngModel"
                        [ngClass]="{
                          'is-invalid': df.submitted && refIsDocument.invalid,
                          'alert-warning':
                            refIsDocument.invalid &&
                            (refIsDocument.dirty ||
                              refIsDocument.touched ||
                              refIsDocument.untouched)
                        }" [(ngModel)]="docModal.IsDocument" required value="0" />
                      Open
                    </label>
                  </span>
                </div>
              </div>
              <div class="col-md-12 p-1" *ngIf="docModal.IsDocument == '1'">
                <span class="required-lable">Type</span>
                <select name="Type" id="Type" #refType="ngModel" [ngClass]="{
                    'is-invalid': df.submitted && refType.invalid,
                    'alert-warning':
                      refType.invalid &&
                      (refType.dirty || refType.touched || refType.untouched)
                  }" [(ngModel)]="docModal.Type" class="form-control input-text-css" (change)="TypeChange($event)"
                  required>
                  <option value="Loan">Loan</option>
                  <option value="Customer">Customer</option>
                  <option value="Assets">Assets</option>
                </select>
              </div>
              <div class="col-md-12 p-1" *ngIf="
                  docModal.Type == 'Customer' && docModal.IsDocument == '1'
                ">
                <span class="required-lable">Select Customer Name</span>
                <select name="Name" id="Name" #refName="ngModel" [ngClass]="{
                    'is-invalid': df.submitted && refName.invalid,
                    'alert-warning':
                      refName.invalid &&
                      (refName.dirty || refName.touched || refName.untouched)
                  }" [(ngModel)]="docModal.Name" class="form-control input-text-css" required>
                  <option value="">Select Customer Name</option>
                  <option *ngFor="let list of CustomerDropdown" [value]="list.Customer + '-' + list.CustomerId">
                    {{ list.Customer }}
                  </option>
                </select>
              </div>
              <div class="col-md-12 p-1" *ngIf="docModal.Type == 'Assets' && docModal.IsDocument == '1'">
                <span class="required-lable">Select Assets Name</span>
                <select name="Name" id="Name" #refName="ngModel" [ngClass]="{
                    'is-invalid': df.submitted && refName.invalid,
                    'alert-warning':
                      refName.invalid &&
                      (refName.dirty || refName.touched || refName.untouched)
                  }" [(ngModel)]="docModal.Name" class="form-control input-text-css" required>
                  <option value="">Select Assets Name</option>
                  <option [value]="asset.ForInsurance" *ngFor="let asset of assetDropdown">
                    {{ asset.ForInsurance }}
                  </option>
                </select>
              </div>
              <div class="col-md-12 p-1" *ngIf="docModal.Type == 'Loan' && docModal.IsDocument == '1'">
                <span class="required-lable">Select Name</span>
                <select name="Name" id="Name" #refName="ngModel" [ngClass]="{
                    'is-invalid': df.submitted && refName.invalid,
                    'alert-warning':
                      refName.invalid &&
                      (refName.dirty || refName.touched || refName.untouched)
                  }" [(ngModel)]="docModal.Name" class="form-control input-text-css" required>
                  <option value="">Select Name</option>
                  <option [value]="CA.Name" *ngFor="let CA of CustomerAssetsDropdown">
                    {{ CA.Name }}
                  </option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div class="col-md-12 p-1" *ngIf="docModal.IsDocument == '1'">
                <span class="required-lable"> Document Category</span>
                <select name="DocId" id="DocId" #refDocId="ngModel" [ngClass]="{
                    'is-invalid': df.submitted && refDocId.invalid,
                    'alert-warning':
                      refDocId.invalid &&
                      (refDocId.dirty || refDocId.touched || refDocId.untouched)
                  }" [(ngModel)]="docModal.DocId" (change)="DocumentCategoryChange($event)"
                  class="form-control input-text-css" required>
                  <option value="">Select Document Category</option>
                  <option [value]="doc.DocumentId + '-' + doc.Doc_CategoryId" *ngFor="let doc of docDropDown">
                    {{ doc.DocumentName }}
                  </option>
                </select>
              </div>
              <div class="col-md-12 p-1">
                <span> Document Type</span>
                <div class="col-md-12 p-1">
                  <span class="form-check-inline">
                    <label class="form-check-label mr-4" for="copyDoc">
                      <input type="radio" class="form-check-input" id="copyDoc" name="IsOrignalDoc"
                        #refIsOrignalDoc="ngModel" [ngClass]="{
                          'is-invalid': df.submitted && refIsOrignalDoc.invalid,
                          'alert-warning':
                            refIsOrignalDoc.invalid &&
                            (refIsOrignalDoc.dirty ||
                              refIsOrignalDoc.touched ||
                              refIsOrignalDoc.untouched)
                        }" [(ngModel)]="docModal.IsOrignalDoc" required value="1" />
                      Copy
                    </label>
                    <label class="form-check-label" for="originalDoc" *ngIf="docModal.IsDocument=='0'">
                      <input type="radio" class="form-check-input" id="originalDoc" name="IsOrignalDoc"
                        #refIsOrignalDoc="ngModel" [(ngModel)]="docModal.IsOrignalDoc" required value="0" [ngClass]="{
                          'is-invalid': df.submitted && refIsOrignalDoc.invalid,
                          'alert-warning':
                            refIsOrignalDoc.invalid &&
                            (refIsOrignalDoc.dirty ||
                              refIsOrignalDoc.touched ||
                              refIsOrignalDoc.untouched)
                        }" />
                      Mark As LOD
                    </label>
                  </span>
                </div>
              </div>
              <div class="col-md-12 p-1">
                <span class="required-lable"> Document Title/Document No.</span>
                <input type="text" #refDocTitle="ngModel" [(ngModel)]="docModal.DocTitle" placeholder=" Document Title"
                  required *ngIf="
                    docModal.DocId.split('-')[0] != 1 &&
                    docModal.DocId.split('-')[0] != 6
                  " name="DocTitle" id="DocTitle" [ngClass]="{
                    'is-invalid': df.submitted && refDocTitle.invalid,
                    'alert-warning':
                      refDocTitle.invalid &&
                      (refDocTitle.dirty ||
                        refDocTitle.touched ||
                        refDocTitle.untouched)
                  }" class="form-control input-text-css" />
                <input type="text" #refDocTitle="ngModel" [(ngModel)]="docModal.DocTitle" placeholder=" Document Title"
                  [ngClass]="{
                    'is-invalid': df.submitted && refDocTitle.invalid,
                    'alert-warning':
                      refDocTitle.invalid &&
                      (refDocTitle.dirty ||
                        refDocTitle.touched ||
                        refDocTitle.untouched)
                  }" name="DocTitle" id="DocTitle" required *ngIf="docModal.DocId.split('-')[0] == 1" maxlength="10"
                  minlength="10" class="form-control input-text-css" />
                <input type="text" numbersOnly #refDocTitle="ngModel" [(ngModel)]="docModal.DocTitle"
                  placeholder=" Document Title" [ngClass]="{
                    'is-invalid': df.submitted && refDocTitle.invalid,
                    'alert-warning':
                      refDocTitle.invalid &&
                      (refDocTitle.dirty ||
                        refDocTitle.touched ||
                        refDocTitle.untouched)
                  }" name="DocTitle" id="DocTitle" required *ngIf="docModal.DocId.split('-')[0] == 6" maxlength="12"
                  minlength="12" class="form-control input-text-css" />
              </div>

              <div class="col-md-12 p-1" *ngIf="docModal.IsOrignalDoc == '0'">
                <span class="">Date Of Execution</span>
                <div class="datepicker_feild">
                  <input [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY" name="DateOfExecution"
                    id="DateOfExecution" required #refDateOfExecution="ngModel" [ngClass]="{
         'is-invalid': df.submitted && refDateOfExecution.invalid,
         'alert-warning':
           refDateOfExecution.invalid &&
           (refDateOfExecution.dirty ||
             refDateOfExecution.touched ||
             refDateOfExecution.untouched)
       }" [(ngModel)]="docModal.DateOfExecution" class="form-control input-text-css" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </div>
              </div>
              <div class="col-md-12 p-1" *ngIf="docModal.IsOrignalDoc == '0'">
                <span> Executed By</span>
                <input type="text" #refExecutedBy="ngModel" [(ngModel)]="docModal.ExecutedBy" placeholder=" Executed By"
                  [ngClass]="{
       'is-invalid': df.submitted && refExecutedBy.invalid,
       'alert-warning':
         refExecutedBy.invalid &&
         (refExecutedBy.dirty ||
           refExecutedBy.touched ||
           refExecutedBy.untouched)
     }" name="ExecutedBy" id="ExecutedBy" class="form-control input-text-css" required />
              </div>
              <div class="col-md-12 p-1">
                <span> No of pages</span>
                <input type="text" #refNo_Of_Pages="ngModel" [(ngModel)]="docModal.No_Of_Pages"
                  placeholder=" No of pages" numbersOnly="true" name="No_Of_Pages" id="No_Of_Pages"
                  class="form-control input-text-css" required [ngClass]="{
                    'is-invalid': df.submitted && refNo_Of_Pages.invalid,
                    'alert-warning':
                      refNo_Of_Pages.invalid &&
                      (refNo_Of_Pages.dirty ||
                        refNo_Of_Pages.touched ||
                        refNo_Of_Pages.untouched)
                  }" />
              </div>
              <div class="col-md-12 p-1">
                <span> Remark </span>
                <input type="text" #refRemark="ngModel" [(ngModel)]="docModal.Remark" placeholder="Remark" name="Remark"
                  id="Remark" class="form-control input-text-css" [ngClass]="{
                    'is-invalid': df.submitted && refRemark.invalid,
                    'alert-warning':
                      refRemark.invalid &&
                      (refRemark.dirty ||
                        refRemark.touched ||
                        refRemark.untouched)
                  }" />
              </div>
              <div class="row m-0 col-md-12 p-1 align-items-center upload">
                <p class="m-0 row align-items-center">
                  Browse Doc:<i class="fa fa-upload ml-2" *ngIf="docModal.DocumentImages.length == 0"
                    (click)="docUFile.click()" aria-hidden="true"></i>
                  <ng-container *ngIf="docModal.DocumentImages.length > 0">
                    <div *ngFor="let doc of docModal.DocumentImages; let i = index">
                      <i class="fa fa-file-pdf mr-2" aria-hidden="true"></i>{{ doc.DocFileName }}
                      <i class="fa fa-times ml-2" aria-hidden="true" style="cursor: pointer"
                        (click)="removeDFile(i)"></i>
                    </div>
                  </ng-container>
                </p>
                <input #docUFile type="file" [multiple]="true"
                  accept="application/pdf,application/vnd.ms-excel,image/jpeg, image/png"
                  (change)="fileChangeListenerD(docUFile.files, docUFile)" style="display: none" />
              </div>
            </div>
            <div class="row m-0 mt-3 col-md-12 p-0 justify-content-end">
              <button type="button" (click)="OnDocClose()" class="mt-2 btn font-size-12 button-btn mr-3">
                Cancel
              </button>
              <button type="button" (click)="onSaveDoc()" *ngIf="!inViewMode" class="mt-2 btn font-size-12 button-btn"
                [class.spinner]="loading" [disabled]="!df.form.valid">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade in" id="docdetailModel" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Doc Attachment
        </h6>
        <button type="button" (click)="OnDocDetailClose()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row m-0 mb2">
          <div class="row m-0 col-md-12 p-1">
            <!-- <i class="fa fa-pencil-alt right btn_detail" aria-label="true" (click)="OnEditApplicationDocs()"></i>
            <div>
              <button type="button" (click)="OnEditApplicationDocs()" style="background-color: #28a745; color: #ffffff; font-size: 0.75rem;"
                mat-raised-button color="primary">
                Edit
              </button>
            </div> -->
            <div class="table-responsive">
              <mat-table [dataSource]="docModalDataSource">
                <ng-container matColumnDef="UDId">
                  <mat-header-cell class="grid-header mw50" *matHeaderCellDef>#</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i = index" class="grid-cell mw50">{{ i + 1 }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Category">
                  <mat-header-cell class="grid-header" *matHeaderCellDef>Doc Category</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.Category
                    }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Type">
                  <mat-header-cell class="grid-header" *matHeaderCellDef>Type</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.Type
                    }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="DocType">
                  <mat-header-cell class="grid-header" *matHeaderCellDef>Doc Type</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.DocType
                    }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="DocTitle">
                  <mat-header-cell class="grid-header" *matHeaderCellDef>Doc Title</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.DocTitle
                    }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="IsReceipt">
                  <mat-header-cell class="grid-header" *matHeaderCellDef>Is Receipt</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.IsReceipt
                    }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="No_Of_Pages">
                  <mat-header-cell class="grid-header" *matHeaderCellDef>No Of Pages</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.No_Of_Pages
                    }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="View">
                  <mat-header-cell class="grid-header" *matHeaderCellDef>View</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">
                    <!-- <a
                      href="{{ docBaseUrl }}{{ loanSummary.ApplicationNo }}/{{
                        row.UD_DocFileName
                      }}"
                      target="_blank"
                    >
                      <i class="fa fa-eye" style="font-size: large"></i>
                    </a> -->
                    <a href="{{ row.DocumentMasterType=='Customer' && row.customerId>0 ?customerProfileBaseUrl:docBaseUrl }}{{ row.DocumentMasterType=='Customer' && row.customerId>0 ?row.customerId:loanSummary.ApplicationNo }}/{{
                        row.UD_DocFileName
                      }}" target="_blank" *ngIf="row.IsLOS"> <i class="fa fa-eye" style="font-size: large"></i></a>
                    <a href="{{ row.DocumentMasterType=='Customer' && row.customerId>0 ?customerProfileBaseUrl:docBaseUrl }}{{ row.DocumentMasterType=='Customer' && row.customerId>0 ?row.customerId:loanSummary.ApplicationNo }}/{{
                        row.UD_DocFileName
                      }}" target="_blank" *ngIf="!row.IsLOS"> <i class="fa fa-eye" style="font-size: large"></i></a>
                    &nbsp; &nbsp;
                    <!-- <i class="fa fa-pencil-alt right btn_detail" aria-label="true" (click)="OnEditApplicationDocs(row)"></i> -->
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedDocModalColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedDocModalColumns"></mat-row>
              </mat-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade in" id="EditDocument" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Upload Application Documents
        </h6>
        <button type="button" (click)="OnCloseDocModal()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row m-0 col-md-12 p-1" *ngIf="docModal">
          <form #df="ngForm" class="row m-0 col-md-12 p-0" (ngSubmit)="OnUpdateDoc()" novalidate>
            <div class="row m-0 col-md-12 p-0">
              <div class="col-md-12 p-1" *ngIf="docModal.DocId != '0-0'">
                <span class="required-lable">Type</span>
                <select name="Type" id="Type" #refType="ngModel" class="form-control input-text-css" required [ngClass]="{
                    'is-invalid': df.submitted && refType.invalid,
                    'alert-warning':
                      refType.invalid &&
                      (refType.dirty || refType.touched || refType.untouched)
                  }" [(ngModel)]="docModal.Type" disabled>
                  <option value="Loan">Loan</option>
                  <option value="Customer">Customer</option>
                  <option value="Assets">Assets</option>
                </select>
              </div>

              <div class="col-md-12 p-1" *ngIf="docModal.DocId != '0-0'">
                <span class="required-lable"> Document Category</span>
                <select name="DocId" id="DocId" #refDocId="ngModel" class="form-control input-text-css" required
                  [ngClass]="{
                    'is-invalid': df.submitted && refDocId.invalid,
                    'alert-warning':
                      refDocId.invalid &&
                      (refDocId.dirty || refDocId.touched || refDocId.untouched)
                  }" [(ngModel)]="docModal.DocId">
                  <option value="">Select Document Category</option>
                  <option [value]="doc.DocumentId + '-' + doc.Doc_CategoryId" *ngFor="let doc of docDropDown">
                    {{ doc.DocumentName }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 p-1" *ngIf="
                  (docModal.KYC_DocId == 3 ||
                    docModal.KYC_DocId == 5 ||
                    docModal.KYC_DocId == 7 ||
                    docModal.KYC_DocId == 21) &&
                  docModal.DocId != '0-0'
                ">
                <span class="required-lable"> Date Of Issue</span>
                <div class="datepicker_feild">
                  <input [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY" name="KYC_IssuedDate"
                    id="KYC_IssuedDate" #refKYC_IssuedDate="ngModel" required (dateChange)="DateChange()" *ngIf="
                      docModal.KYC_DocId == 3 ||
                      docModal.KYC_DocId == 5 ||
                      docModal.KYC_DocId == 7 ||
                      docModal.KYC_DocId == 21
                    " [ngClass]="{
                      'is-invalid': df.submitted && refKYC_IssuedDate.invalid,
                      'alert-warning':
                        refKYC_IssuedDate.invalid &&
                        (refKYC_IssuedDate.dirty ||
                          refKYC_IssuedDate.touched ||
                          refKYC_IssuedDate.untouched)
                    }" [(ngModel)]="docModal.KYC_IssuedDate" class="form-control input-text-css" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </div>
                <!-- <input
                  name="KYC_IssuedDate"
                  id="KYC_IssuedDate"
                  #refKYC_IssuedDate="ngModel"
                  required
                  (ngModelChange)="DateChange()"
                  *ngIf="
                    docModal.KYC_DocId == 3 ||
                    docModal.KYC_DocId == 5 ||
                    docModal.KYC_DocId == 7 ||
                    docModal.KYC_DocId == 21
                  "
                  [ngClass]="{
                    'is-invalid': df.submitted && refKYC_IssuedDate.invalid,
                    'alert-warning':
                      refKYC_IssuedDate.invalid &&
                      (refKYC_IssuedDate.dirty ||
                        refKYC_IssuedDate.touched ||
                        refKYC_IssuedDate.untouched)
                  }"
                  [(ngModel)]="docModal.KYC_IssuedDate"
                  value="{{ docModal.KYC_IssuedDate | date : 'dd/MM/yyyy' }}"
                  placeholder="DD/MM/YYYY"
                  class="form-control input-text-css"
                  [(bsValue)]="docModal.KYC_IssuedDate"
                  bsDatepicker
                /> -->
              </div>
              <div class="col-md-6 p-1" *ngIf="
                  (docModal.KYC_DocId == 3 ||
                    docModal.KYC_DocId == 5 ||
                    docModal.KYC_DocId == 7 ||
                    docModal.KYC_DocId == 21) &&
                  docModal.DocId != '0-0'
                ">
                <span class="required-lable"> Date Of Expire</span>
                <div class="datepicker_feild">
                  <input [matDatepicker]="picker2" dateConvert placeholder="DD/MM/YYYY" name="KYC_ExpiredDate"
                    id="KYC_ExpiredDate" #refKYC_ExpiredDate="ngModel" required (dateChange)="DateChange()" *ngIf="
                      docModal.KYC_DocId == 3 ||
                      docModal.KYC_DocId == 5 ||
                      docModal.KYC_DocId == 7 ||
                      docModal.KYC_DocId == 21
                    " [ngClass]="{
                      'is-invalid': df.submitted && refKYC_ExpiredDate.invalid,
                      'alert-warning':
                        refKYC_ExpiredDate.invalid &&
                        (refKYC_ExpiredDate.dirty ||
                          refKYC_ExpiredDate.touched ||
                          refKYC_ExpiredDate.untouched)
                    }" [(ngModel)]="docModal.KYC_ExpiredDate" class="form-control input-text-css" />
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </div>
                <!-- <input
                  name="KYC_ExpiredDate"
                  id="KYC_ExpiredDate"
                  #refKYC_ExpiredDate="ngModel"
                  required
                  (ngModelChange)="DateChange()"
                  *ngIf="
                    docModal.KYC_DocId == 3 ||
                    docModal.KYC_DocId == 5 ||
                    docModal.KYC_DocId == 7 ||
                    docModal.KYC_DocId == 21
                  "
                  [ngClass]="{
                    'is-invalid': df.submitted && refKYC_ExpiredDate.invalid,
                    'alert-warning':
                      refKYC_ExpiredDate.invalid &&
                      (refKYC_ExpiredDate.dirty ||
                        refKYC_ExpiredDate.touched ||
                        refKYC_ExpiredDate.untouched)
                  }"
                  [(ngModel)]="docModal.KYC_ExpiredDate"
                  value="{{ docModal.KYC_ExpiredDate | date : 'dd/MM/yyyy' }}"
                  placeholder="DD/MM/YYYY"
                  class="form-control input-text-css"
                  [(bsValue)]="docModal.KYC_ExpiredDate"
                  bsDatepicker
                /> -->
              </div>
              <div class="col-md-12 p-1">
                <span> Document Type</span>
                <div class="col-md-12 p-1">
                  <span class="form-check-inline">
                    <label class="form-check-label mr-4" for="copyDoc">
                      <input type="radio" class="form-check-input" id="originalDoc" name="IsOrignalDoc"
                        #refIsOrignalDoc="ngModel" [ngClass]="{
                          'is-invalid': df.submitted && refIsOrignalDoc.invalid,
                          'alert-warning':
                            refIsOrignalDoc.invalid &&
                            (refIsOrignalDoc.dirty ||
                              refIsOrignalDoc.touched ||
                              refIsOrignalDoc.untouched)
                        }" [(ngModel)]="docModal.IsOrignalDoc" required [value]="1"
                        [checked]="docModal.IsOrignalDoc == 1" />
                      Copy
                    </label>
                    <!--<label class="form-check-label" for="originalDoc">
                      <input
                        type="radio"
                        class="form-check-input"
                        id="originalDoc"
                        name="IsOrignalDoc"
                        #refIsOrignalDoc="ngModel"
                        [ngClass]="{
                          'is-invalid': df.submitted && refIsOrignalDoc.invalid,
                          'alert-warning':
                            refIsOrignalDoc.invalid &&
                            (refIsOrignalDoc.dirty ||
                              refIsOrignalDoc.touched ||
                              refIsOrignalDoc.untouched)
                        }"
                        [(ngModel)]="docModal.IsOrignalDoc"
                        required
                        [value]="0"
                        [checked]="docModal.IsOrignalDoc == 0"
                      />
                      Mark As LOD
                    </label>-->
                  </span>
                </div>
              </div>
              <div class="col-md-12 p-1">
                <span class="required-lable"> Document Title/Document No.</span>
                <input type="text" #refDocTitle="ngModel" [(ngModel)]="docModal.DocTitle" placeholder=" Document Title"
                  *ngIf="
                    docModal.DocId.split('-')[0] != 1 &&
                    docModal.DocId.split('-')[0] != 6
                  " [ngClass]="{
                    'is-invalid': df.submitted && refDocTitle.invalid,
                    'alert-warning':
                      refDocTitle.invalid &&
                      (refDocTitle.dirty ||
                        refDocTitle.touched ||
                        refDocTitle.untouched)
                  }" name="DocTitle" id="DocTitle" class="form-control input-text-css" required />
                <input type="text" #refDocTitle="ngModel" [(ngModel)]="docModal.DocTitle" placeholder=" Document Title"
                  [ngClass]="{
                    'is-invalid': df.submitted && refDocTitle.invalid,
                    'alert-warning':
                      refDocTitle.invalid &&
                      (refDocTitle.dirty ||
                        refDocTitle.touched ||
                        refDocTitle.untouched)
                  }" name="DocTitle" id="DocTitle" required *ngIf="docModal.DocId.split('-')[0] == 1" maxlength="10"
                  minlength="10" class="form-control input-text-css" />
                <input type="text" numbersOnly #refDocTitle="ngModel" [(ngModel)]="docModal.DocTitle"
                  placeholder=" Document Title" [ngClass]="{
                    'is-invalid': df.submitted && refDocTitle.invalid,
                    'alert-warning':
                      refDocTitle.invalid &&
                      (refDocTitle.dirty ||
                        refDocTitle.touched ||
                        refDocTitle.untouched)
                  }" name="DocTitle" id="DocTitle" required *ngIf="docModal.DocId.split('-')[0] == 6" maxlength="12"
                  minlength="12" class="form-control input-text-css" />
              </div>
              <div class="col-md-12 p-1">
                <span> No of pages</span>
                <input type="text" #refNo_Of_Pages="ngModel" [(ngModel)]="docModal.No_Of_Pages"
                  placeholder=" No of pages" numbersOnly="true" [ngClass]="{
                    'is-invalid': df.submitted && refNo_Of_Pages.invalid,
                    'alert-warning':
                      refNo_Of_Pages.invalid &&
                      (refNo_Of_Pages.dirty ||
                        refNo_Of_Pages.touched ||
                        refNo_Of_Pages.untouched)
                  }" name="No_Of_Pages" id="No_Of_Pages" class="form-control input-text-css" required />
              </div>
              <div class="col-md-12 p-1">
                <span> Remark </span>
                <input type="text" #refRemark="ngModel" [(ngModel)]="docModal.Remark" placeholder=" Remark " [ngClass]="{
                    'is-invalid': df.submitted && refRemark.invalid,
                    'alert-warning':
                      refRemark.invalid &&
                      (refRemark.dirty ||
                        refRemark.touched ||
                        refRemark.untouched)
                  }" name="Remark" id="Remark" class="form-control input-text-css" />
              </div>
              <div class="row m-0 col-md-12 p-1 align-items-center upload">
                <p class="m-0 row align-items-center">
                  <span class="col-md-12 p-1">
                    Browse Doc:
                    <i class="fa fa-upload ml-2" (click)="docUFile.click()" aria-hidden="true"></i>
                  </span>
                  <!-- *ngIf="docModal.DocumentImages.length==0" -->
                  <ng-container *ngIf="docModal.DocumentImages.length > 0">
                    <div *ngFor="let doc of docModal.DocumentImages; let i = index">
                      <i class="fa fa-file-pdf mr-2" aria-hidden="true"></i>{{ doc.DocFileName }}
                      <i class="fa fa-times ml-2" aria-hidden="true" style="cursor: pointer"
                        (click)="removeDFile(i)"></i>
                    </div>
                  </ng-container>
                </p>
                <input #docUFile type="file" [multiple]="true"
                  accept="application/pdf,application/vnd.ms-excel,image/jpeg, image/png"
                  (change)="fileChangeListenerD(docUFile.files, docUFile)" style="display: none" />
              </div>
            </div>
            <div class="row m-0 mt-3 col-md-12 p-0 justify-content-end">
              <button type="button" (click)="OnCloseDocModal()" class="btn btn-light font-size-12 mr-3">
                Cancel
              </button>
              <button type="button" (click)="OnUpdateDoc()" mat-raised-button class="btn font-size-12 button-btn"
                [class.spinner]="loading" [disabled]="!df.form.valid">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>